import { applyMiddleware, compose, createStore, combineReducers } from 'redux';
import createHistory from 'history/createBrowserHistory';

import { push, routerMiddleware, connectRouter } from 'connected-react-router';
import thunkMiddleware from 'redux-thunk';

import { reducer as formReducer } from 'redux-form';
import ensighten from './Ensighten/EnsightenReducer';
import fpti from './FPTI/FPTIReducer';
import pageCount from './PageCount/PageCountReducer';
import serverData from './ServerData/ServerDataReducer';
import spinner from '../components/FullPageSpinner/FullPageSpinnerReducer';
import skeletonPage from '../App/SkeletonPage/SkeletonPageReducer';
import fci from './ReportFCI/ReportFCIReducer';
import globalVarMiddleware from './customMiddleware/globalVarMiddleware';
import fptiMiddleware from './customMiddleware/fptiMiddleware';

import _ from 'lodash';

export const history = createHistory();

export const middleware = [globalVarMiddleware, thunkMiddleware, routerMiddleware(history), fptiMiddleware];

export let store = null;

export default (initialState, countryReducers, hot) => {
    store = createStore(
        getCombinedReducers(countryReducers),
        initialState,
        compose(
            applyMiddleware(...middleware),
            window.devToolsExtension ? window.devToolsExtension() : f => f
        )
    );

    if (
        process &&
        process.env &&
        (process.env.DEBUG || process.env.NODE_ENV === 'test')
    ) {
        // save the internal references to the window.cape
        _.set(window, 'cape.store', store);
        _.set(window, 'cape.push', push);
    }

    return store;
};

const getCombinedReducers = (countryReducers) => {
    return connectRouter(history)(combineReducers(
        Object.assign({},
            {
                // first assign the framework ones
                ensighten,
                form: formReducer,
                fpti,
                pageCount,
                serverData,
                skeletonPage,
                spinner,
                fci
            },
            // then add on the reducers for this country
            countryReducers
        )
    ));
};
